import { initialProps } from '@utils/initial'
import { routes } from '@group-devs/yfp7-global-modules/data/lcw'
import Error from '../404'
import Head from 'next/head';
import {LcwLayout,IndexHeaderWYD,PhysiciansDiseasedOriented,WhoDoYouTurn,LessSixPercent,WantToLearn,TakeAPeekWYD,FreeReportWYD} from '@components/Block'

export async function getServerSideProps({req, res, query}) {
    return {
        props: await initialProps(req, res, query, routes.wyd)
    }
}

const wyd = (props) => {
    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    return (
        <LcwLayout global={props}
            ogurl="/what-your-doctor-wasnt-taught" 
            ogsiteName="What your Doctor wasn&#039;t Taught in Med School"
            ogsiteDesc="Less than 6% of Doctors get formal training in nutrition. Don't rely on them to get the knowledge you need to build health. Click here to download this report today." 
            ogImg="../images/wyd/img-doctor-webinar-share02.jpg"
            ogIcon="../images/wyd/img-favicon-wyd01.png"
        >            
            <IndexHeaderWYD global={props}/>
            <PhysiciansDiseasedOriented/>
            <WhoDoYouTurn/>
            <LessSixPercent/>
            <WantToLearn/>
            <TakeAPeekWYD/>
            <FreeReportWYD global={props}/>
        </LcwLayout>
    )
}

export default wyd